<template>
    <main id="login" class="h-100">
        <div class="container-fluid h-100">
            <b-row class="h-100">
                <b-col id="bg-side" md="12">
                    <LanguageSwitch />
                    <div class="loginCard">
                        <div id="logo" class="position-relative" />
                        <b-form
                            class="d-flex login-form flex-column justify-content-center w-50 mx-auto"
                            @submit.prevent="doForgetPassword"
                        >
                            <b-form-group
                                id="email-input-group"
                                :label="$t('message.yourEmail')"
                                label-for="email-input"
                            >
                                <b-form-input
                                    id="email-input"
                                    v-model="loginForm.email"
                                    v-validate="'required|email'"
                                    class="form-mail"
                                    name="email"
                                    placeholder=""
                                    trim
                                    type="email"
                                />
                                <span v-if="isSubmit" class="text-danger mt-3">{{ errors.first("email") }}</span>
                            </b-form-group>

                            <b-button :disabled="loading" class="mt-4 login-btn" type="submit" variant="primary">
                                <span v-if="loading">
                                    <b-spinner small type="grow" />
                                </span>
                                <span v-else>
                                    {{ $t("message.lostPassword") }}
                                </span>
                            </b-button>
                            <a-divider class="text-light">{{ $t("message.or") }}</a-divider>

                            <div class="d-flex justify-content-center flex-column">
                                <b-button
                                    class="mt-4 login-btn-extra"
                                    type="button"
                                    variant="secondary"
                                    @click="() => $router.push('login')"
                                >
                                    {{ $t("message.loginWithPassword") }}
                                </b-button>
                                <b-button
                                    class="mt-4 login-btn-extra"
                                    type="button"
                                    variant="secondary"
                                    @click="() => $router.push('passwordless-login')"
                                >
                                    {{ $t("message.loginWithEmail") }}
                                </b-button>
                            </div>
                        </b-form>
                    </div>
                </b-col>
            </b-row>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";
import LanguageSwitch from "../../components/LanguageSwitch";

export default {
    name: "ForgotPassword",
    components: { PasswordForgot, LanguageSwitch },

    data() {
        return {
            loading: false,
            isSubmit: false,
            loginForm: {
                email: "",
                password: "",
            },
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
        }),
    },
    methods: {
        ...mapActions({
            forgotPassword: "auth/forgotPassword",
        }),
        doForgetPassword() {
            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    this.forgotPassword(this.loginForm)
                        .then((z) => {
                            this.$bvToast.toast(this.$t("message.forgetPasswordSent"), {
                                title: this.$t("message.successful"),
                                variant: "success",
                                solid: true,
                            });
                            setTimeout(() => {
                                this.$router.push("login");
                            }, 3000);
                        })
                        .catch((error) => {
                            if (error.response.data.localizedMessages) {
                                this.$bvToast.toast(
                                    this.language.code === "en"
                                        ? error.response.data.localizedMessages.en
                                        : error.response.data.localizedMessages.tr,
                                    {
                                        title: this.$t("message.error"),
                                        variant: "danger",
                                        solid: true,
                                    }
                                );
                            } else {
                                console.error("error --> ", error);
                                this.$bvToast.toast(error.response.data, {
                                    title: error.response.statusText || "Error",
                                    variant: "danger",
                                    solid: true,
                                });
                            }
                        })
                        .finally(() => (this.loading = false));
                }
            });
        },
    },
};
</script>
